import { NgModule } from '@angular/core';
import {SortPipe} from './sort/sort.pipe';
import {UnderscoreToSpacePipe} from './underscore-to-space/underscore-to-space.pipe';
import { CamelCaseToTitleCasePipe } from './camel-case-to-title-case/camel-case-to-title-case.pipe';

@NgModule({
  imports: [
    SortPipe,
    UnderscoreToSpacePipe,
    CamelCaseToTitleCasePipe
  ],
  exports: [
    SortPipe,
    UnderscoreToSpacePipe,
    CamelCaseToTitleCasePipe
  ]
})
export class PipesModule { }
